import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/")({
  component: Index,
})

// The Dashboard (/home) has been retired. The authenticated root redirects to the Inbox
function Index() {
  return <Navigate to="/inbox" replace />
}
